import styled from 'styled-components';

const SidebarContainer = styled.div`
  text-align: center;

  &.rtl {
    .sidebar-header {
      flex-direction: row-reverse;
    }
    .links a,
    .category-btn {
      flex-direction: row-reverse;
      text-align: right;
    }
    .chevron {
      transform: rotate(180deg);
    }
    .section-title {
      text-align: right;
      padding-right: 1.5rem;
      padding-left: 0;
    }
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ffffff;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-100%);
    z-index: -1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .show-sidebar {
    transform: translateX(0);
    z-index: 999;
  }

  .sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.5rem;
    background: #ffffff;
    border-bottom: 1px solid #f0f0f0;
    min-height: 70px;
    
    img {
      width: 140px;
      height: auto;
      max-height: 60px;
      object-fit: contain;
      border-radius: 8px;
    }
  }

  .close-btn {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
    border: none;
    border-radius: 12px;
    color: #dc2626;
    font-size: 1.1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(220, 38, 38, 0.15);

    &:hover {
      background: linear-gradient(135deg, #fecaca 0%, #fca5a5 100%);
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }
  }

  .nav-section {
    padding: 0.5rem 0;
    background: #ffffff;
  }

  .section-title {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: #94a3b8;
    padding: 1rem 1.5rem 0.5rem;
    text-align: left;
    margin: 0;
    background: #ffffff;
  }

  .links {
    margin: 0;
    padding: 0;
    list-style: none;
    background: #ffffff;

    li {
      margin: 0;
    }

    a {
      display: flex;
      align-items: center;
      gap: 1rem;
      padding: 1rem 1.5rem;
      color: #334155;
      text-decoration: none;
      font-size: 1rem;
      font-weight: 500;
      transition: all 0.3s ease;
      border-left: 3px solid transparent;
      background: #ffffff;

      &:hover {
        background: linear-gradient(90deg, rgba(45, 212, 191, 0.08) 0%, transparent 100%);
        border-left-color: #2dd4bf;
        color: #0d9488;

        .link-icon {
          color: #2dd4bf;
          transform: scale(1.1);
        }

        .chevron {
          opacity: 1;
          transform: translateX(3px);
        }
      }

      &:active {
        background: rgba(45, 212, 191, 0.12);
      }
    }
  }

  .link-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
    border-radius: 10px;
    color: #64748b;
    font-size: 1rem;
    transition: all 0.3s ease;
  }

  .link-text {
    flex: 1;
    text-align: left;
  }

  .chevron {
    color: #cbd5e1;
    font-size: 0.75rem;
    opacity: 0.5;
    transition: all 0.3s ease;
  }

  /* Categories Section */
  .categories-section {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid #f0f0f0;
    flex: 1;
    background: #f8fafc;
  }

  .categories-list {
    margin: 0;
    padding: 0.5rem 1rem 2rem;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;

    li {
      flex: 0 0 calc(50% - 0.25rem);
    }
  }

  .category-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.875rem 1rem;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    color: #475569;
    font-size: 0.875rem;
    font-weight: 500;
    text-transform: capitalize;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

    &:hover {
      background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
      border-color: #99f6e4;
      color: #0d9488;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(45, 212, 191, 0.15);

      .chevron {
        opacity: 1;
        color: #2dd4bf;
      }
    }

    &:active {
      transform: translateY(0);
    }

    .category-name {
      flex: 1;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .chevron {
      font-size: 0.65rem;
      color: #94a3b8;
      opacity: 0.6;
      transition: all 0.3s ease;
    }
  }

  @media screen and (min-width: 992px) {
    .sidebar {
      display: none;
    }
  }
`;

export default SidebarContainer;
